var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n  flex-grow: 0;\n  align-content: center;\n  margin-left: auto;\n  width: 50%;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n  flex-grow: 0;\n  align-content: center;\n  margin-left: auto;\n  width: 50%;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-weight: 500;\n  font-family: ', ';\n  color: ', ';\n  align-self: center;\n  margin: 0;\n  font-size: 12px;\n  line-height: 0.8;\n  white-space: nowrap;\n  display: flex;\n  align-content: center;\n'], ['\n  font-weight: 500;\n  font-family: ', ';\n  color: ', ';\n  align-self: center;\n  margin: 0;\n  font-size: 12px;\n  line-height: 0.8;\n  white-space: nowrap;\n  display: flex;\n  align-content: center;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  &:hover {\n    text-decoration: none;\n    opacity: .8;\n  }\n  @media(max-width: 1199px){\n    ', ' {\n      display: none;\n    }\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  &:hover {\n    text-decoration: none;\n    opacity: .8;\n  }\n  @media(max-width: 1199px){\n    ', ' {\n      display: none;\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { useState } from 'react';
import styled from 'styled-components';
import { SearchIcon, ShopIcon, EmailIcon } from '../Icons';
import { Montserrat } from '../../assets/fonts';
import { gold } from '../../assets/colors';
import getPgaTld from '../../getPgaTld';
import HeaderMailModal from '../HeaderMailModal';
import handleMailClick from '../HeaderMailModal/handleMailClick';

export var IconsBox = styled.div(_templateObject);

export var StyledText = styled.span(_templateObject2, Montserrat, gold);

export var ExternalLinkWrapper = styled.a.attrs(function (_ref) {
  var target = _ref.target;
  return {
    target: target,
    rel: target === '_blank' ? 'noopener noreferrer' : ''
  };
})(_templateObject3, StyledText);

var pgaTld = getPgaTld();

export default (function (_ref2) {
  var isLoggedIn = _ref2.isLoggedIn,
      _ref2$meEmailMigratio = _ref2.meEmailMigrationData,
      meEmailMigrationData = _ref2$meEmailMigratio === undefined ? {} : _ref2$meEmailMigratio,
      onToggleDoNotShowAgain = _ref2.onToggleDoNotShowAgain,
      me = _ref2.me;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = useState(),
      modalType = _useState2[0],
      setModalType = _useState2[1];

  return React.createElement(
    IconsBox,
    null,
    React.createElement(HeaderMailModal, { open: open, onToggle: setOpen, type: modalType, meEmailMigrationData: meEmailMigrationData, onToggleDoNotShowAgain: onToggleDoNotShowAgain, me: me }),
    React.createElement(
      ExternalLinkWrapper,
      {
        href: 'https://resources.' + pgaTld
      },
      React.createElement(SearchIcon, { className: 'd-flex' })
    ),
    !isLoggedIn ? React.createElement(
      ExternalLinkWrapper,
      {
        href: 'https://account.' + pgaTld + '/login?return_to=https://account.' + pgaTld + '/mail-redirect'
      },
      React.createElement(EmailIcon, { pr: 5, className: 'd-flex' })
    ) : React.createElement(
      'div',
      { onClick: function onClick() {
          return handleMailClick({ meEmailMigrationData: meEmailMigrationData, setModalType: setModalType, setOpen: setOpen });
        } },
      React.createElement(EmailIcon, { pr: 5, className: 'd-flex' })
    ),
    React.createElement(
      ExternalLinkWrapper,
      {
        target: '_blank',
        href: 'https://shopmyshop.com/?application=a496c986-a442-46b0-bdaf-4cfca0a61c93'
      },
      React.createElement(ShopIcon, { pr: 5, className: 'd-flex' })
    )
  );
});